import { Injectable } from '@angular/core';
import { UsernameRecoveryInfo } from '../models/username-recovery-info';

@Injectable({
  providedIn: 'root',
})
export class UsernameRecoveryService {
  setCache(info: UsernameRecoveryInfo) {
    sessionStorage.setItem('username-recovery-info', JSON.stringify(info));
  }

  getCache(): UsernameRecoveryInfo | undefined {
    const storedInfo = sessionStorage.getItem('username-recovery-info');

    return storedInfo ? (JSON.parse(storedInfo) as UsernameRecoveryInfo) : undefined;
  }

  clearCache() {
    sessionStorage.removeItem('username-recovery-info');
  }
}
